const Sms = () =>
  import(
    /* webpackChunkName: "system-gateway-sms" */ '@/pages/system/gateway/sms/index.vue'
  )
const CreateSms = () =>
  import(
    /* webpackChunkName: "system-gateway-sms" */ '@/pages/system/gateway/sms/create.vue'
  )
const EditSms = () =>
  import(
    /* webpackChunkName: "system-gateway-sms" */ '@/pages/system/gateway/sms/edit.vue'
  )

export default {
  path: 'sms',
  meta: {
    label: 'sms',
    auth: 'sms'
  },
  component: {
    name: 'Sms',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'SystemGatewaySms',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Sms
    },
    {
      name: 'SystemCreateGatewaySms',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateSms
    },
    {
      name: 'SystemEditGatewaySms',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditSms,
      props: true
    }
  ]
}
